import { AuthService } from "./../../shared/models/auth.service";
import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions } from "@angular/http";
import { InstanceModel } from "./instance.model";
import { Observable } from "rxjs/Observable";
import { WeGoConfig, IAPIResponse, DataListModel } from "../../shared/config";
import { CloneEntityModel } from "./cloneentity.model";

@Injectable()
export class InstanceService {
  constructor(private authService: AuthService, private http: Http) { }

  public GetInstanceList(
    input?: DataListModel,
    customerHashId?: string
  ): Observable<IAPIResponse> {
    let getInstanceUrl = WeGoConfig.API_GET_INSTANCE_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getInstanceUrl = getInstanceUrl + "?" + queryString;
    }
    if (customerHashId) {
      getInstanceUrl = getInstanceUrl + "&customerHashId=" + customerHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportInstanceList(
    input?: DataListModel,
    customerHashId?: string
  ): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getInstanceUrl =
      WeGoConfig.API_EXPORT_INSTANCE_LIST + "?" + queryString;
    if (customerHashId) {
      getInstanceUrl = getInstanceUrl + "&customerHashId=" + customerHashId;
    }
    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getInstanceUrl, options);
  }

  public GetInstanceByHashId(instanceHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl =
        WeGoConfig.API_GET_INSTANCE_BY_HASH + "?instanceHashId=" + instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
        .get(getInstanceUrl, options)
        .map(this.authService.HandleAPIResponse)
        .catch(this.authService.HandleAPIError);
  }

  public GetInstanceByCompanyHashId(companyHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl =
        WeGoConfig.API_GET_INSTANCE_BY_COMPANY_HASH + "?companyHashId=" + companyHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
        .get(getInstanceUrl, options)
        .map(this.authService.HandleAPIResponse)
        .catch(this.authService.HandleAPIError);
  }

  public GetInstanceBasicDetail(
    instanceHashId: string
  ): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_GET_INSTANCE_BASIC_DETAIL +
      "?instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  // public CloneInstance(
  //   cloneEntityModel : CloneEntityModel
  // ): Observable<IAPIResponse> {
  //   let getVehicleUrl =
  //     WeGoConfig.API_CLONE_INSTANCE +
  //     "?existingInstanceHashId=" +
  //     existingInstanceHashId +
  //     "&newInstanceName=" +
  //     newInstanceName;
  //   let headers = this.authService.GetHeader();
  //   let options = new RequestOptions({ headers: headers });
  //   return this.http
  //     .get(getVehicleUrl, options)
  //     .map(this.authService.HandleAPIResponse)
  //     .catch(this.authService.HandleAPIError);
  // }

  public CloneInstance(cloneEntityModel: CloneEntityModel): Observable<IAPIResponse> {
    let body = cloneEntityModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_CLONE_INSTANCE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  // public CloneInstance(cloneEntityModel: CloneEntityModel): Observable<IAPIResponse> {

  //   let body = cloneEntityModel;
  //   let headers = this.authService.GetHeader();
  //   let options = new RequestOptions({ headers: headers });

  //   let url= WeGoConfig.API_CLONE_INSTANCE_DETAIL;

  //   return this.http.get(url, body, options)
  //     .map(this.authService.HandleAPIResponse)
  //     .catch(this.authService.HandleAPIError);
  // }



  // public CloneInstance(cloneEntityModel: any): Observable<IAPIResponse> {
  //   let url= WeGoConfig.API_CLONE_INSTANCE_DETAIL + "?intanceHashId=" + intanceHashId;
  //   let headers = this.authService.GetHeader();
  //   let options = new RequestOptions({ headers: headers });

  //   return this.http
  //     .get(getInstanceUrl, options)
  //     .map(this.authService.HandleAPIResponse)
  //     .catch(this.authService.HandleAPIError);
  // }

  public AddNewInstance(bodyData: any): Observable<IAPIResponse> {
    let body = bodyData;
    let headers = this.authService.GetHeader(
      "application/json",
      "application/x-www-form-urlencoded"
    );
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_INSTANCE_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteInstance(intanceHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_DELETE_INSTANCE + "?intanceHashId=" + intanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetImportAllowedInstance(): Observable<IAPIResponse> {
    let getInstanceUrl = WeGoConfig.API_GET_IMPORT_ALLOWED_INSTANCE_LIST;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public CheckIsAllowToImportPerson() {
    let getInstanceUrl = WeGoConfig.API_GET_IMPORT_ALLOWED_TO_USER;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public CheckIsAllowToBatchUploadPerson() {
    let getInstanceUrl = WeGoConfig.API_GET_BATCH_UPLOAD_ALLOW_TO_USER;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public IsOdometerEnabled(instanceHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_ODOMETER_ENABLED + "?instanceHashId=" + instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetBatchUploadDetailByHashId(instanceHashId: string) {
    let getBatchUploadDetail =
      WeGoConfig.API_GET_BATCH_UPLOAD_DETAIL_BY_HASH +
      "?instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getBatchUploadDetail, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetInstanceForBatchUpload(
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getInstanceUrl = WeGoConfig.API_GET_INSTANCES_FOR_BATCH_UPLOAD;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getInstanceUrl = getInstanceUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public IsDirectDebitEnabledForCompany(instanceHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_DIRECTDEBIT_ENABLED_COMPANY +
      "?instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public IsDirectDebitEnabled(instanceHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_DIRECTDEBIT_ENABLED +
      "?instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public IsTwoFaEnabled(instanceHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_TWOFA_ENABLED +
      "?instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetInstanceLanguage(instanceHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_INSTANCE_LANGUAGE +
      "?instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public IsNIFNumberEnabled(instanceHashId: string) {
    let getNIFNumberEnabledUrl =
      WeGoConfig.API_GET_NIF_NUMBER_ENABLED +
      "?instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getNIFNumberEnabledUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCountryCode(instanceHashId: string) {
    let getCountryCodeURL =
      WeGoConfig.API_GET_COUNTRYCODE +
      "?instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCountryCodeURL, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public PaymentSettingRequiredOnInstance(instanceHashId: string) {
    let getInactiveCompanyAdminUrl =
      WeGoConfig.API_GET_PAYMENTSETTING_REQUIRED_ON_INSTANCE +
      "?instanceHashId=" +
      instanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInactiveCompanyAdminUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }


  public ResetTwoFaCookies(intanceHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_RESET_TWOFA_COOKIES_INSTANCE + "?intanceHashId=" + intanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ResetTwoFaKeys(intanceHashId: string): Observable<IAPIResponse> {
    let getInstanceUrl =
      WeGoConfig.API_RESET_TWOFA_KEYS_INSTANCE + "?intanceHashId=" + intanceHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownInstanceList(
    moduleName: string,
    customerHashId?: string
  ): Observable<IAPIResponse> {
    let getInstanceUrl: string;
    switch (moduleName) {
      case "Vehicle_Occupancy_Report":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_VEHICLEOCCUPANCYREPORT;
        break;
      case "Revenue_Per_Vehicle_Report":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_REVENUEVEHICLEREPORT;
        break;
      case "Maintenance_Planning_Report":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_MAINTENCEPLANNINGREPORT;
        break;
      case "TripData_Report":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_TRIPDATAREPORT;
        break;
      case "Admin_Dashboard":
        getInstanceUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_DASHBOARD;
        break;
      case "Error_Log":
        getInstanceUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_ERRORLOG;
        break;
      case "Terms_And_Condition":
        getInstanceUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_TERMSANDCONDITIONS;
        break;
      case "Cost_Center_Report":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_FOR_COST_CENTER_REPORT;
        break;
      case "Kick_Back_Report":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_KICKBACKREPORT;
        break;
      default:
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_VEHICLEOCCUPANCYREPORT;
        break;
    }

    if (customerHashId) {
      getInstanceUrl = getInstanceUrl + "?customerHashId=" + customerHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetInstanceListDropdownForAddUpdatePage(
    pageName: string,
    permissionType: string,
    customerHashId?: string
  ): Observable<IAPIResponse> {
    let getInstanceUrl: string;
    switch (pageName) {
      case "Vehicle_Attribute_Category":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_CATEGORY_ATTRIBUTE;
        break;
      case "Vehicle_Attribute":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_VEHICLE_ATTRIBUTE;
        break;
      case "Template":
        getInstanceUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_TEMPLATE;
        break;
      case "SignupFormConfig":
        getInstanceUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_SIGNUPCONFIG;
        break;
      case "person":
        getInstanceUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_PERSON;
        break;
      case "company":
        getInstanceUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_COMPANY;
        break;
      case "Organization":
        getInstanceUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_ORGANIZATION;
        break;
      case "Branding":
        getInstanceUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_BRANDING;
        break;
      case "ErrorEsclation":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_ERRORESCLATION;
        break;
      case "Terms_And_Condition":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_TERMSANDCONDITIONS;
        break;
      case "invoice_update":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_INVOICE_UPDATE;
        break;
      case "Pre Post Trip Question":
        getInstanceUrl =
          WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_FOR_PRE_POST_TRIP_QUESTION;
        break;
      default:
        getInstanceUrl = WeGoConfig.API_GET_INSTANCE_LIST;
        break;
    }

    if (permissionType) {
      getInstanceUrl = getInstanceUrl + "?permissionType=" + permissionType;
    }
    if (customerHashId) {
      getInstanceUrl = getInstanceUrl + "&customerHashId=" + customerHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getInstanceUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetDropdownTimeZoneList(
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getInstanceTimeZoneListUrl =
      WeGoConfig.API_GET_DROPDOWN_INSTANCE_TIMEZONE_LIST;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getInstanceTimeZoneListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSharedVehicleGroupList(instanceHashId?: string): Observable<IAPIResponse> {
    let getSVGUrl = WeGoConfig.API_GET_SHAREDVEHICLEGROUP_DETAIL + "?instanceHashId=" + instanceHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.get(getSVGUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetOrganizationListBySharedVehicleGroup(instanceHashId?: string, sharedVehicleGroupHashId?: string): Observable<IAPIResponse> {
    let getSVGUrl = WeGoConfig.API_GET_ORGANIZATION_DETAIL + "?instanceHashId=" + instanceHashId + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.get(getSVGUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetSubscriptionListByOrganization(organizationHashId?: string): Observable<IAPIResponse> {
    let getSubscriptionUrl = WeGoConfig.API_GET_SUBSCRIPTION_LIST_FOR_ORGANIZATION + "?organizationHashId=" + organizationHashId;

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http.get(getSubscriptionUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/instance/models/instance.service.ts